export default "__VITE_ASSET__DWQEJZQp__"